export const buildingLines: { [keys: string]: any } = {
  "magic-lens": {
    points: [717.5, 549, 791.5, 518, 811.5, 474, 793.5, 454, 759.5, 165, 737.5, 245, 725.5, 228,
      711.5, 219, 690.5, 154, 665.5, 222, 646.5, 235, 636.5, 254, 618.5, 173, 602.5, 329, 590.5,
      462, 578.5, 477, 578.5, 500, 599.5, 532, 669.5, 549],
    closed: true
  },
  "magic-palace": {
    points: [610, 555, 784, 557, 880, 478, 880, 442, 849, 418, 850, 372, 825, 357, 817, 166, 741,
      100, 645, 96, 571, 155, 557, 361, 540, 382, 541, 413, 512, 435, 512, 483],
    closed: true
  },
  "training-fields": {
    points: [424.5, 413, 572.5, 310, 573.5, 278, 459.5, 232, 458.5, 219, 446.5, 214, 450.5, 170,
      417.5, 145, 387.5, 179, 383.5, 221, 374.5, 241, 270.5, 288, 270.5, 311],
    closed: true
  },
  barracks: {
    points: [419, 411, 560, 324, 562, 270, 545, 262, 539, 276, 471, 256, 472, 221, 484, 185, 474,
      165, 428, 155, 383, 167, 377, 183, 385, 251, 369, 253, 363, 250, 347, 251, 348, 199, 322, 192,
      297, 191, 272, 199, 258, 205, 261, 242, 267, 252, 269, 325, 275, 337, 304, 343, 405, 412],
    closed: true
  },
  "siege-workshop": {
    points: [524.5, 364, 567.5, 333, 575.5, 280, 533.5, 238, 505.5, 250, 503.5, 223, 474.5, 222,
      472.5, 191, 465.5, 179, 449.5, 179, 446.5, 225, 436.5, 223, 429.5, 216, 368.5, 243, 361.5,
      238, 329.5, 275, 311.5, 278, 314.5, 302, 320.5, 311, 311.5, 318, 313.5, 334, 355.5, 368,
      366.5, 370, 385.5, 366, 398.5, 389, 427.5, 396, 437.5, 386, 485.5, 378, 522.5, 365],
    closed: true
  },
  school: {
    points: [461.5, 641, 521.5, 605, 522.5, 561, 510.5, 504, 497.5, 503, 463.5, 441, 420.5, 459,
      414.5, 425, 379.5, 429, 377.5, 475, 358.5, 473, 357.5, 487, 328.5, 496, 304.5, 547, 305.5,
      561, 318.5, 564, 316.5, 591, 365.5, 625, 400.5, 610],
    closed: true
  },
  university: {
    points: [423.5, 707, 595.5, 602, 592.5, 532, 564.5, 467, 547.5, 510, 533.5, 507, 519.5, 477,
      513.5, 478, 510.5, 499, 467.5, 481, 462.5, 458, 449.5, 443, 448.5, 399, 433.5, 363, 421.5,
      394, 423.5, 433, 407.5, 442, 378.5, 419, 366.5, 390, 360.5, 394, 355.5, 418, 327.5, 435,
      317.5, 466, 319.5, 478, 284.5, 494, 275.5, 482, 278.5, 437, 266.5, 398, 246.5, 434, 249.5,
      460, 248.5, 492, 230.5, 514, 233.5, 582],
    closed: true
  },
  "town-hall": {
    points: [1056.5, 705, 1043.5, 685, 1044.5, 657, 1050.5, 649, 1048.5, 583, 1022.5, 541, 1006.5,
      545, 1005.5, 525, 959.5, 470, 907.5, 531, 913.5, 575, 868.5, 592, 851.5, 622, 830.5, 628,
      834.5, 674, 910.5, 724, 952.5, 698, 979.5, 711, 992.5, 705, 1028.5, 723],
    closed: true
  },
  embassy: {
    points: [1051.5, 697, 1055.5, 690, 1053.5, 667, 1091.5, 643, 1101.5, 622, 1101.5, 467, 1041.5,
      450, 1009.5, 459, 989.5, 483, 988.5, 497, 978.5, 511, 952.5, 510, 927.5, 531, 889.5, 516,
      853.5, 516, 815.5, 536, 810.5, 556, 808.5, 714, 864.5, 748, 904.5, 742, 970.5, 707, 986.5,
      712, 1001.5, 709, 1006.5, 711, 1020.5, 704],
    closed: true
  },
  palace: {
    points: [1060.5, 781, 1092.5, 748, 1114.5, 749, 1158.5, 722, 1190.5, 712, 1173.5, 646, 1148.5,
      624, 1147.5, 592, 1165.5, 574, 1167.5, 522, 1157.5, 503, 1149.5, 502, 1151.5, 467, 1136.5,
      440, 1120.5, 476, 1117.5, 509, 1102.5, 505, 1103.5, 488, 1090.5, 473, 1053.5, 467, 1053.5,
      454, 1033.5, 428, 1015.5, 455, 1015.5, 466, 986.5, 484, 962.5, 448, 948.5, 449, 932.5, 432,
      923.5, 471, 914.5, 481, 893.5, 459, 882.5, 485, 881.5, 523, 852.5, 533, 832.5, 499, 819.5,
      525, 818.5, 574, 826.5, 598, 820.5, 644, 801.5, 682, 900.5, 753, 919.5, 752, 974.5, 785,
      981.5, 800, 1005.5, 809],
    closed: true
  },
  caravans: {
    points: [663.5, 693, 670.5, 666, 670.5, 658, 705.5, 659, 761.5, 675, 800.5, 684, 817.5, 643,
      804.5, 637, 794.5, 644, 767.5, 640, 766.5, 611, 730.5, 612, 717.5, 615, 663.5, 623, 648.5,
      610, 609.5, 617, 604.5, 632, 581.5, 634, 547.5, 650, 547.5, 678, 573.5, 692, 619.5, 716,
      654.5, 708],
    closed: true
  },
  "center-of-trade": {
    points: [718.5, 747, 734.5, 749, 780.5, 730, 816.5, 718, 848.5, 697, 845.5, 676, 829.5, 672,
      811.5, 633, 804.5, 624, 801.5, 599, 752.5, 575, 732.5, 606, 724.5, 604, 704.5, 576, 655.5,
      598, 646.5, 609, 633.5, 637, 627.5, 634, 600.5, 597, 569.5, 645, 570.5, 675, 609.5, 702,
      641.5, 708, 649.5, 714, 646.5, 726, 670.5, 754],
    closed: true
  },
  "red-dragon-inn": {
    points: [1261.5, 582, 1307.5, 553, 1304.5, 478, 1280.5, 446, 1278.5, 396, 1259.5, 396, 1258.5,
      416, 1183.5, 393, 1161.5, 397, 1131.5, 440, 1130.5, 460, 1139.5, 475, 1127.5, 529, 1148.5,
      543, 1143.5, 551, 1175.5, 569, 1194.5, 560, 1238.5, 582],
    closed: true
  },
  "dragon-tail-brothel": {
    points: [1172.5, 610, 1267.5, 560, 1286.5, 564, 1315.5, 544, 1312.5, 438, 1322.5, 433, 1291.5,
      365, 1246.5, 355, 1240.5, 341, 1228.5, 340, 1223.5, 351, 1196.5, 409, 1132.5, 426, 1102.5,
      462, 1101.5, 498, 1091.5, 528, 1081.5, 537, 1080.5, 567, 1097.5, 567],
    closed: true
  },
  guild: {
    points: [1398.5, 493, 1518.5, 428, 1510.5, 415, 1509.5, 375, 1523.5, 369, 1448.5, 290, 1331.5,
      327, 1309.5, 324, 1305.5, 359, 1313.5, 361, 1289.5, 390, 1305.5, 398, 1304.5, 424, 1293.5,
      430, 1292.5, 474, 1324.5, 488, 1358.5, 476],
    closed: true
  },
  "workshop-level-1": {
    points: [1445.5, 323, 1444.5, 316, 1482.5, 288, 1482.5, 285, 1516.5, 265, 1512.5, 170, 1394.5,
      129, 1371.5, 165, 1367.5, 147, 1344.5, 146, 1332.5, 222, 1305.5, 243, 1311.5, 255, 1290.5,
      282, 1298.5, 316, 1335.5, 336, 1356.5, 330, 1379.5, 342],
    closed: true
  },
  "workshop-level-2": {
    points: [1466.5, 308, 1485.5, 311, 1552.5, 267, 1550.5, 226, 1530.5, 210, 1525.5, 114, 1500.5,
      110, 1495.5, 155, 1390.5, 120, 1368.5, 156, 1366.5, 138, 1342.5, 136, 1331.5, 214, 1304.5,
      228, 1305.5, 243, 1293.5, 267, 1299.5, 301, 1332.5, 319, 1356.5, 317, 1380.5, 325],
    closed: true
  },
  "workshop-level-3": {
    points: [1437.5, 327, 1459.5, 322, 1479.5, 323, 1518.5, 292, 1554.5, 270, 1547.5, 223, 1528.5,
      210, 1522.5, 113, 1502.5, 113, 1496.5, 156, 1412.5, 125, 1409.5, 85, 1386.5, 83, 1379.5, 142,
      1370.5, 153, 1368.5, 141, 1343.5, 138, 1329.5, 215, 1304.5, 230, 1306.5, 248, 1290.5, 270,
      1299.5, 303, 1336.5, 322, 1351.5, 315, 1421.5, 345],
    closed: true
  },
  "water-tower": {
    points: [1698.5, 309, 1716.5, 299, 1713.5, 267, 1688.5, 260, 1686.5, 250, 1684.5, 241, 1677.5,
      172, 1693.5, 153, 1692.5, 120, 1653.5, 86, 1612.5, 116, 1617.5, 128, 1617.5, 161, 1631.5, 174,
      1626.5, 248, 1595.5, 288, 1614.5, 310, 1678.5, 307],
    closed: true
  },
  drainage: {
    points: [1641.5, 309, 1645.5, 283, 1710.5, 240, 1698.5, 229, 1677.5, 239, 1672.5, 234, 1674.5,
      219, 1654.5, 210, 1650.5, 239, 1657.5, 250, 1625.5, 269, 1622.5, 298, 1607.5, 308, 1622.5,
      324],
    closed: true
  },
  sewer: {
    points: [1641.5, 320, 1751.5, 262, 1722.5, 238, 1684.5, 253, 1651.5, 265, 1649.5, 272, 1610.5,
      296, 1609.5, 309],
    closed: true
  },
  aquaduct: {
    points: [1542.5, 238, 1707.5, 333, 1725.5, 324, 1725.5, 215, 1747.5, 194, 1743.5, 143, 1554.5,
      90, 1534.5, 92, 1535.5, 122, 1546.5, 166],
    closed: true
  },
  palisade: {
    points: [651.5, 856, 843.5, 769, 843.5, 705, 810.5, 693, 793.5, 698, 788.5, 739, 771.5, 752,
      769.5, 712, 735.5, 704, 713.5, 718, 715.5, 782, 698.5, 787, 695.5, 741, 668.5, 736, 650.5,
      739, 643.5, 757, 641.5, 853],
    closed: true
  },
  walls: {
    points: [670.5, 841, 697.5, 845, 730.5, 843, 856.5, 768, 857.5, 703, 864.5, 695, 862.5, 684,
      853.5, 681, 843.5, 688, 828.5, 685, 733.5, 736, 714.5, 744, 697.5, 744, 683.5, 738, 570.5,
      679, 558.5, 679, 545.5, 671, 536.5, 674, 537.5, 688, 542.5, 692, 543.5, 765],
    closed: true
  },
  "magic-walls": {
    points: [676.5, 846, 701.5, 849, 728.5, 841, 850.5, 770, 854.5, 706, 858.5, 699, 858.5, 687,
      849.5, 685, 837.5, 691, 822.5, 684, 732.5, 735, 711.5, 745, 692.5, 745, 572.5, 680, 558.5,
      681, 542.5, 673, 535.5, 677, 535.5, 693, 539.5, 695, 541.5, 767],
    closed: true
  },
  "tower-of-time": {
    points: [1044.5, 424, 1059.5, 416, 1058.5, 378, 1037.5, 346, 1023.5, 364, 996.5, 334, 999.5,
      216, 985.5, 132, 941.5, 132, 930.5, 199, 926.5, 284, 930.5, 340, 911.5, 369, 893.5, 357,
      879.5, 383, 877.5, 421, 896.5, 433, 913.5, 424, 923.5, 417, 950.5, 426, 956.5, 431, 979.5,
      428, 985.5, 417, 1001.5, 408],
    closed: true
  },
  "palace-of-time": {
    points: [1051.5, 453, 1114.5, 417, 1115.5, 384, 1090.5, 373, 1090.5, 324, 1081.5, 304, 1067.5,
      305, 1065.5, 291, 1050.5, 280, 1048.5, 239, 1032.5, 219, 1025.5, 217, 1023.5, 204, 1010.5,
      198, 1006.5, 130, 982.5, 113, 951.5, 132, 944.5, 203, 937.5, 208, 924.5, 185, 920.5, 187,
      905.5, 222, 902.5, 226, 901.5, 263, 891.5, 270, 889.5, 280, 878.5, 286, 879.5, 303, 876.5,
      308, 872.5, 317, 852.5, 318, 854.5, 292, 846.5, 287, 841.5, 253, 833.5, 290, 828.5, 296,
      831.5, 305, 830.5, 388, 930.5, 445, 951.5, 438, 969.5, 447, 993.5, 435, 1003.5, 438, 1008.5,
      433],
    closed: true,
  },
  "thieves-guild": {
    points: [1178.5, 396, 1225.5, 371, 1242.5, 377, 1269.5, 359, 1278.5, 344, 1279.5, 305, 1221.5,
      252, 1190.5, 263, 1158.5, 277, 1121.5, 321, 1131.5, 340, 1124.5, 363, 1127.5, 386, 1157.5,
      394],
    closed: true
  },
  "manufactory-level-1": {
    points: [1177.5, 257, 1202.5, 262, 1218.5, 260, 1235.5, 251, 1254.5, 261, 1323.5, 228, 1324.5,
      199, 1334.5, 195, 1305.5, 150, 1300.5, 151, 1273.5, 158, 1265.5, 162, 1253.5, 139, 1227.5,
      148, 1225.5, 135, 1219.5, 136, 1217.5, 107, 1201.5, 93, 1186.5, 94, 1177.5, 113, 1173.5,
      150, 1160.5, 154, 1150.5, 177, 1103.5, 188, 1043.5, 216, 1044.5, 236, 1074.5, 252, 1063.5,
      266, 1061.5, 274, 1102.5, 290],
    closed: true
  },
  "manufactory-level-2": {
    points: [1176.5, 307, 1221.5, 285, 1216.5, 265, 1232.5, 251, 1277.5, 274, 1323.5, 249, 1319.5,
      221, 1320.5, 199, 1331.5, 194, 1304.5, 150, 1290.5, 145, 1289.5, 93, 1265.5, 95, 1216.5,
      116, 1203.5, 97, 1180.5, 98, 1175.5, 112, 1171.5, 149, 1159.5, 153, 1153.5, 174, 1149.5, 178,
      1111.5, 186, 1044.5, 215, 1045.5, 232, 1075.5, 247, 1062.5, 265, 1098.5, 282, 1123.5, 276,
      1141.5, 286],
    closed: true
  },
  "manufactory-level-3": {
    points: [1224.5, 284, 1213.5, 263, 1234.5, 252, 1282.5, 277, 1325.5, 247, 1322.5, 227, 1319.5,
      199, 1333.5, 192, 1308.5, 148, 1290.5, 148, 1288.5, 90, 1226.5, 109, 1217.5, 116, 1205.5, 98,
      1181.5, 95, 1178.5, 109, 1163.5, 103, 1164.5, 87, 1109.5, 86, 1111.5, 150, 1109.5, 155,
      1054.5, 172, 1041.5, 191, 1042.5, 231, 1076.5, 251, 1057.5, 266, 1099.5, 282, 1115.5, 277,
      1131.5, 282, 1169.5, 308],
    closed: true
  },
  "field-level-1": {
    points: [1623.5, 594, 1794.5, 493, 1792.5, 479, 1636.5, 413, 1478.5, 487, 1478.5, 511],
    closed: true
  },
  "field-level-2": {
    points: [1623.5, 594, 1794.5, 493, 1792.5, 479, 1636.5, 413, 1478.5, 487, 1478.5, 511],
    closed: true
  },
  "field-level-3": {
    points: [1624.5, 604, 1796.5, 498, 1796.5, 484, 1655.5, 394, 1618.5, 398, 1503.5, 451, 1499.5,
      480, 1477.5, 494, 1477.5, 517],
    closed: true
  },
  "stone-mine-level-1": {
    points: [37.5, 309, 114.5, 352, 184.5, 309, 171.5, 266, 126.5, 230, 88.5, 229, 57.5, 247, 40.5,
      273, 37.5, 300],
    closed: true
  },
  "stone-mine-level-2": {
    points: [172.5, 306, 156.5, 260, 141.5, 256, 119.5, 231, 86.5, 229, 59.5, 244, 38.5, 272, 36.5,
      305, 40.5, 327, 101.5, 349, 136.5, 348, 153.5, 338, 192.5, 351, 198.5, 342],
    closed: true
  },
  "stone-mine-level-3": {
    points: [172.5, 306, 156.5, 260, 141.5, 256, 119.5, 231, 86.5, 229, 59.5, 244, 38.5, 272, 36.5,
      305, 40.5, 327, 101.5, 349, 136.5, 348, 153.5, 338, 192.5, 351, 198.5, 342],
    closed: true
  },
  "iron-mine-level-1": {
    points: [144.5, 226, 178.5, 217, 223.5, 224, 264.5, 208, 286.5, 189, 264.5, 169, 212.5, 138,
      197.5, 123, 167.5, 139, 137.5, 144, 103.5, 170, 111.5, 193, 138.5, 191, 159.5, 202, 137.5,
      217],
    closed: true
  },
  "iron-mine-level-2": {
    points: [144.5, 226, 178.5, 217, 223.5, 224, 264.5, 208, 286.5, 189, 264.5, 169, 212.5, 138,
      197.5, 123, 167.5, 139, 137.5, 144, 103.5, 170, 111.5, 193, 71.5, 213, 95.5, 231, 141.5, 206],
    closed: true
  },
  "iron-mine-level-3": {
    points: [130.5, 220, 143.5, 233, 170.5, 222, 211.5, 223, 233.5, 230, 287.5, 197, 259.5, 168,
      245.5, 159, 219.5, 152, 193.5, 128, 187.5, 107, 167.5, 109, 169.5, 122, 137.5, 142, 130.5,
      136, 97.5, 149, 94.5, 188, 106.5, 196, 74.5, 216, 97.5, 232, 130.5, 218],
    closed: true
  },
  "grove-level-1": {
    points: [123.5, 465, 143.5, 484, 172.5, 468, 233.5, 475, 238.5, 425, 278.5, 413, 273.5, 357,
      257.5, 333, 226.5, 321, 203.5, 335, 188.5, 355, 153.5, 334, 120.5, 348, 103.5, 357, 93.5, 381,
      71.5, 381, 57.5, 427, 60.5, 445, 92.5, 448, 89.5, 489],
    closed: true
  },
  "grove-level-2": {
    points: [173.5, 520, 200.5, 485, 234.5, 472, 244.5, 420, 286.5, 411, 276.5, 360, 249.5, 333,
      226.5, 327, 192.5, 357, 156.5, 339, 128.5, 345, 104.5, 365, 89.5, 382, 69.5, 384, 54.5, 434,
      86.5, 450, 93.5, 494, 103.5, 497, 142.5, 495, 159.5, 519],
    closed: true
  },
  "grove-level-3": {
    points: [146.5, 495, 169.5, 518, 228.5, 518, 254.5, 464, 296.5, 434, 320.5, 402, 274.5, 358,
      254.5, 328, 227.5, 326, 217.5, 304, 174.5, 297, 137.5, 304, 131.5, 339, 99.5, 372, 96.5, 384,
      69.5, 384, 54.5, 435, 93.5, 454, 95.5, 495, 107.5, 497],
    closed: true
  }
}

export const buildingChainCategories: {[keys: string]: any} = {
  guild: {
    15: "farmer",
    16: "stoneMiner",
    17: "ironMiner",
    18: "druid",
    19: "baker",
    20: "mason",
    21: "smith",
    22: "trader",
    23: "alchemist"
  },
  workshop: {
    24: "baker",
    25: "mason",
    26: "smith",
    27: "trader",
    28: "alchemist"
  },
  manufacture: { 29: "baker", 30: "mason", 31: "smith" }
}
